import { useState } from "react";
import UsersAction from "./UsersAction";
import InfoUser from "./InfoUser";
import EditUser from "./EditUser";
import DeleteUser from "./DeleteUser";


function RowUsers({ item, index, onSelect, isSelected }) {
    const [openModal, setOpenModal] = useState(null);
    const handleChecked = (checked) => onSelect(item.id, checked)

    const isChecked = isSelected.includes(item.id);

    const rowBg = isChecked
        ? "bg-blue-200"
        : index % 2
            ? "bg-primary-100 hover:bg-slate-100"
            : "bg-white hover:bg-slate-100";

    return (
        <>
            <div className={`flex flex-row-reverse items-center justify-between text-right p-2 text-sm ${rowBg}`}>
                <div className="flex flex-row-reverse">
                    <input
                        type="checkbox"
                        className="ml-2 w-8 h-4 cursor-pointer"
                        checked={isChecked}
                        onChange={(e) => handleChecked(e.target.checked)}
                    />
                    <p className="w-52">{item.name}</p>
                    <p className="w-52">{item.family}</p>
                    <p className="w-52">{item.userName}</p>
                    <p className="w-52">{item.mobile}</p>
                </div>
                <UsersAction onOpen={setOpenModal} />
            </div>

            {openModal === "details" && <InfoUser user={item} close={() => setOpenModal(null)} />}
            {openModal === "edit" && <EditUser user={item} close={() => setOpenModal(null)} />}
            {openModal === "delete" && <DeleteUser user={item} close={() => setOpenModal(null)} />}
        </>
    );
}
export default RowUsers;